import { Provider } from '@angular/core';
import { MSBaseUrl } from 'src/app/adapters/http/utils/http.utils';
import { FeatureFlags } from 'src/app/use-case/feature-flags/utils/feature-flag.models';
import { ProviderWithProvide } from 'src/app/utils/dependency-injection.utils';
import { BrowserAppConfig } from 'src/configs/app/app.config';
import { LongDistanceConfigSpec } from 'src/configs/distance/long-distance.config';
import { ShortDistanceConfigSpec } from 'src/configs/distance/short-distance.config';
import { MapConfig } from 'src/configs/maps.config';

export interface Environment {
  production: boolean;
  name: string;
  serverUrl: MSBaseUrl;
  distanceConfig: ShortDistanceConfigSpec | LongDistanceConfigSpec;
  browserAppConfig: BrowserAppConfig;
  mapConfig: MapConfig;
}

export interface DevEnvironment extends Environment {
  production: boolean;
  devServiceProviders: Provider[];
  mockAssetProviders: ProviderWithProvide[];
  featureFlags: Partial<FeatureFlags>;
}

export function logEnvironmentInfo(environment: Environment) {
  console.log(`environment: ${environment.name}; version: ${environment.browserAppConfig.version}`);
}
